import { create } from 'zustand';

const useAIStore = create((set) => ({
  // AI behavior controls
  tone: 'friendly',
  mode: 'confirm',
  scope: 'session',

  setTone: (tone) => set({ tone }),
  setMode: (mode) => set({ mode }),
  setScope: (scope) => set({ scope }),

  // Floating AI trigger system
  trigger: false,
  prompt: '',
  memory: {},
  sourceModule: '',

  // Call this from any module to open AI with memory/prompt
  triggerAI: ({ prompt, memory, sourceModule }) =>
    set({
      trigger: true,
      prompt,
      memory,
      sourceModule: sourceModule || '',
    }),

  clearTrigger: () =>
    set({
      trigger: false,
      prompt: '',
      memory: {},
      sourceModule: '',
    }),
}));

export default useAIStore;
